export default {
      id: "icon-play-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "icons.svg#icon-play",
      toString: function () {
        return this.url;
      }
    }